;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.pennylane', [
      'kilo.routes.pennylane.inbox'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  /**
   * State de retour OAuth Pennylane (redirectUri enregistrée chez Pennylane).
   * Pennylane redirige ici avec `?code=…&state=…` en query string HTTP classique :
   * l'app est en html5Mode(true) (cf. main.config.js) donc ces paramètres sont
   * bien lus par ui-router/$location — pas de hashbang à gérer.
   * ⚠️ Sans ce state déclaré, `$urlRouterProvider.otherwise('/invoice/list')`
   * avalerait l'URL de retour et le `code` (usage unique) serait perdu.
   */
  function RouteConfigurator ($stateProvider) {
    var callbackState = {
      name: 'pennylane-callback',
      url: '/pennylane/callback?code&state',
      params: {
        // dynamic : permet de nettoyer la query string (code mort dans
        // l'historique) après l'échange, SANS recharger le controller.
        code: { dynamic: true, value: null },
        state: { dynamic: true, value: null }
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/pennylane/callback/templates/pennylane-callback.template.html',
          controller: 'PennylaneCallbackController',
          controllerAs: 'callback'
        }
      },
      ncyBreadcrumb: {
        label: 'Connexion Pennylane'
      }
    }

    $stateProvider.state(callbackState)
  }
})(window.angular)
